import styled, { keyframes } from "styled-components";
import { mobileAuthSideContainer, mobileAuthMainContainer } from "../../../styles/authShellMixins";

// Animações
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Container principal
export const MainContainer = styled.div`
  position: relative;
  display: flex;
  //flex-direction: column;
  //align-items: center;
  width: 100%;
  height: 100%;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;

  ${mobileAuthMainContainer}
`;

export const SideContainer = styled.div`
  scrollbar-width: none; 
  overflow-y: auto; 
  overflow-x: hidden; 
  position: relative; 
  height: 100vh; 
  min-height: 100vh; 
  width: ${({ collapsed }) => (collapsed ? "calc(100% - 6vw)" : "calc(100% - 15vw)")};
  margin: auto;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out; 
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza horizontalmente */
  justify-content: flex-start; /* Alinha no topo */

  &::-webkit-scrollbar {
    display: none; /* Remove scrollbar no Chrome/Safari */
  }

  ${mobileAuthSideContainer}
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto; /* Centraliza horizontalmente */
`;

// Padrão de fundo decorativo
export const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  background-image: 
    radial-gradient(circle at 25% 25%, var(--accent-secondary) 2px, transparent 2px),
    radial-gradient(circle at 75% 75%, var(--accent) 1px, transparent 1px);
  background-size: 100px 100px, 60px 60px;
  z-index: 0;
`;

// Seção do cabeçalho
export const HeaderSection = styled.header`
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
`;

// Título principal
export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px color-mix(in srgb, var(--accent-secondary) 30%, transparent);
  text-align: center;
  animation: ${fadeInUp} 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// Subtítulo
export const Subtitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--text-heading);
  margin: 0;
  letter-spacing: 0.05em;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;


// Grid de botões
export const ButtonGrid = styled.div`
  position: fixed;
  bottom: 90vh;   /* 5% da altura da tela */
  right: 4vw;    /* 3% da largura da tela */
  display: flex;
  justify-content: flex-end;
  width: auto;
  //z-index: 1000;
`;



// Botão de ação
export const ActionButton = styled.button`
  position: relative;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  border-radius: 20px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 20vw;
  height: 26vh;
  overflow: hidden;
  
  /* Pseudo-elemento para o gradiente de fundo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--accent-secondary-soft) 0%, var(--accent-soft) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 20px;
    z-index: 1;
    box-shadow: inset 0 0 20px var(--accent-soft);
  }
  
  /* Pseudo-elemento para a sombra externa que se move junto */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: transparent;
    box-shadow: 0 12px 32px var(--accent-soft);
    opacity: 0;
    transition: all 0.4s ease;
    z-index: -1;
    pointer-events: none;
  }
  
  &:hover::before {
    opacity: 1;
  }
  
  &:hover::after {
    opacity: 1;
    transform: translateY(-8px); /* Sombra se move junto com o botão */
  }
  
  &:hover {
    transform: translateY(-8px);
    border-color: var(--accent);
    box-shadow: inset 0 1px 0 var(--surface-glass-strong);
  }
  
  &:active {
    transform: translateY(-4px);
  }
  
  &:active::after {
    transform: translateY(-4px);
  }
  
  @media (max-width: 768px) {
    width: 20vw;
    height: 24vh;
    padding: 1.8rem;
  }
  
  @media (max-width: 480px) {
    width: 80vw;
    height: 20vh;
    padding: 1.5rem;
  }
  
  > * {
    position: relative;
    z-index: 2;
  }
`;

// Descrição do botão
export const ButtonDescription = styled.p`
  font-size: 0.8rem;
  color: var(--text-heading);
  margin: 0;
  line-height: 1.4;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  ${ActionButton}:hover & {
    opacity: 1;
    color: var(--text-heading);
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const StyledButton = styled.button`
  background: ${props => props.secondary 
    ? 'var(--input-bg)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-subtle)' 
    : 'var(--border-default)'};
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;
  marginLeft: "auto"

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      ${props => props.secondary 
        ? 'var(--input-bg) 0%, var(--surface-glass) 100%' 
        : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'}
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background: transparent;
    box-shadow: ${props => props.secondary 
      ? 'var(--shadow-sm)' 
      : '0 6px 15px var(--accent-soft)'};
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary 
      ? 'var(--text-muted)' 
      : 'var(--accent)'};
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;

export const SmallActionButton = styled(ActionButton)`
  flex-direction: row;        
  align-items: center;        
  justify-content: center; 
  gap: 0.5rem;                
  padding: 0.8rem 1rem;
  width: 14vw;    
  height: 6vh;        

  @media (max-width: 768px) {
    padding: 0.6rem 0.8rem;
    gap: 0.4rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.6rem;
    gap: 0.3rem;
  }
`;

// Ícone do botão
export const ButtonIcon = styled.div`
  font-size: 1.2rem;
  display: flex;              /* 🔥 garante centralização */
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 4px 8px var(--accent-soft));

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

// Texto do botão
export const ButtonText = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: var(--accent-secondary);
  margin: 0;                  /* 🔥 remove margem que desalinhava */
  line-height: 1.3;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;


export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1%;
  margin: 1%;
`;

export const SearchBox = styled.div`
  height: 8vh;
  width: 38vw;
  display: flex;
  background-color: var(--text-on-accent);
  margin: 0 auto;
  border-radius: 20px;
  border: 1px solid var(--border-default);
  overflow: hidden;
`;

export const SelectStyled = styled.select`
  display: flex;
  outline: none;
  padding-left: 0.2rem;
  font-size: 0.9rem;
  border-radius: 10px;
  border: 1px solid var(--border-default);
`;

export const InputStyled = styled.input`
  margin: 0.5%;
  padding: 1rem;
  border: none;
  outline: none;
  font-size: 1rem;
`;

export const AreaListWrapper = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;     
  //width: 100%;             
  margin: 0 auto;
  overflow: hidden;
  //background: red;          
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0.5%;
`;

export const ButtonContainerLeft = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ButtonContainerRight = styled.div`
  display: flex;
  gap: 0.5rem;
`;